// extracted by mini-css-extract-plugin
module.exports = {"deactivatedLabel":"_1UCr7"};